import script from "./CorporateTaxReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./CorporateTaxReturn.vue?vue&type=script&setup=true&lang=js"

import "./CorporateTaxReturn.vue?vue&type=style&index=0&id=5e4ab973&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4ab973"]])

export default __exports__